import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import ChangePasswordModal from '../setup/ChangePasswordModal';
import './UserDots.css';
import hamberger from '.././image/hamberger.png';
import { showValidationAlert } from '../CustomBannerAlert';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function UserDots() {
    const { username, userid, logout } = useContext(AuthContext);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
    const navigate = useNavigate();

    const handleDotsClick = () => {
        if (userid) {
            setIsMenuOpen(!isMenuOpen);
        }
    };

    const handleChangePasswordClick = () => {
        setIsChangePasswordOpen(true);
        setIsMenuOpen(false);
    };

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const handleOnSuccess = (data) => {
        setIsChangePasswordOpen(false);
        showValidationAlert(data, "success");
    
        // Wait for 3 seconds before logging out
        setTimeout(() => {
            handleLogout();
        }, 2000);
    };
    

    return (
        <>
            {/* Wrapper div to position everything in the extreme top-right */}
            <div className="user-dots-wrapper">
                <ToastContainer />
                <div className="user-dots-container">
                    <FaUserCircle className="user-icon" />

                    {/* Dots menu button */}
                    <div className="dots-img-container" onClick={handleDotsClick}>
                        <img src={hamberger} alt="Menu" className="dots-img-icon" />
                    </div>
                </div>
                <p className="username">{username}</p>

                {/* Menu Modal */}
                {isMenuOpen && (
                    <div className="menu-modal">
                        <div className="menu-modal-content">
                            <button onClick={() => setIsMenuOpen(false)} className="close-btn">X</button>
                            {/* Show User & Role and Activity Logs for admin */}
                            {userid.toLowerCase().includes("admin") && (
                                <button onClick={() => navigate('/userrole')} className="button-link">User & Role</button>

                            )}
                            {userid.toLowerCase().includes("admin") && (
                                <button onClick={() => navigate('/activitylogs')} className="button-link">User Activity Logs</button>
                            )}
                            {/* Show Change Password only if NOT admin */}
                            {!userid.toLowerCase().includes("admin") && (
                                <button onClick={handleChangePasswordClick} className="button-link">Change Password</button>
                            )}

                            {/* Log Out (for all users) */}
                            <button onClick={handleLogout} className="logout logout-button-link">Log Out</button>
                        </div>
                    </div>
                )}

                {/* Change Password Modal */}
                {isChangePasswordOpen && (
                    <ChangePasswordModal isOpen={isChangePasswordOpen} onClose={() => setIsChangePasswordOpen(false)} onSuccess={handleOnSuccess} />
                )}

            </div>

        </>
    );
}

export default UserDots;
